<template>
  <div class="articles-page">
    <!-- 1. Top Header Banner Section (uses sliced image directly) -->
    <section class="events-header">
      <img :src="require('@/assets/images/events_header_collage.png')" alt="Articles Header" class="header-banner-img" />
    </section>

    <!-- 2. Main Article List Section (high-end white background with black text) -->
    <section class="articles-body">
      <div class="container">
        
        <!-- 2.1 Featured Full-Width Card (Dynamic) -->
        <div v-if="articles.length > 0" class="featured-card" @click="navigateToArticle(articles[0].id)">
          <div class="featured-img-wrapper">
            <img :src="getImage(articles[0].imageSrc) || require('@/assets/images/event_featured_sunset.png')" :alt="articles[0].title" class="featured-img" />
            <div class="featured-overlay">
              <h2>{{ articles[0].title }}</h2>
              <p class="featured-date">{{ articles[0].date }}</p>
              <p class="featured-desc">{{ articles[0].desc }}</p>
            </div>
          </div>
        </div>

        <!-- 2.2 Grid Cards List (2 rows by 3 columns, fully replicated) -->
        <div class="event-grid">
          <div 
            class="event-card" 
            v-for="article in articles.slice(1)" 
            :key="article.id" 
            @click="navigateToArticle(article.id)"
          >
            <div class="event-img">
              <img v-if="article.imageSrc" :src="getImage(article.imageSrc)" :alt="article.title" />
            </div>
            <div class="event-details">
              <h3>{{ article.title }}</h3>
              <p class="event-date">{{ article.date }}</p>
              <p class="event-desc">{{ article.desc }}</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EventsPage',
  data() {
    return {
      articles: []
    };
  },
  mounted() {
    axios.get('/api/events')
      .then(response => {
        let fetchedArticles = response.data;
        // 按创建时间精确到毫秒倒序排序（过滤掉 'article-' 前缀）
        fetchedArticles.sort((a, b) => {
          let timeA = parseInt(a.id.replace(/[^0-9]/g, '')) || 0;
          let timeB = parseInt(b.id.replace(/[^0-9]/g, '')) || 0;
          return timeB - timeA;
        });
        this.articles = fetchedArticles;
      })
      .catch(error => {
        console.error('Failed to fetch events list:', error);
      });
  },
  methods: {
    navigateToArticle(id) {
      this.$router.push(`/article/${id}`);
    },
    getImage(srcString){
      if (!srcString) return '';
      if (srcString.startsWith('/api/') || srcString.startsWith('http')) {
        return srcString;
      }
      const fileName=srcString.split('/').pop(); // Extract filename
      try{
        return require(`@/assets/images/${fileName}`);
      }
      catch(e){
        return srcString;
      }
    }
  }
};
</script>

<style scoped>
/* ==========================================
   Top Banner Section
   ========================================== */
.events-header {
  width: 100%;
  font-size: 0; /* Eliminate small gaps under the img */
  background-color: #0b0d1e; /* Keep dark background to prevent white edges */
}

.header-banner-img{
    width: 1920px;
    height: 400px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%);
}

/* ==========================================
   Main Article List Body
   ========================================== */
.articles-body {
  background-color: #ffffff;
  padding: 5rem 0 8rem 0;
  width: 100%;
}

.container {
  width: 1312px !important; /* Force override global 1200px settings to align with the 1312px card */
  max-width: 100%;
  margin: 0 auto !important; /* Ensure absolute centering */
  padding: 0 24px;
  box-sizing: border-box;
}

/* Featured Card */
.featured-card {
  width: 100%;
  margin-bottom: 4.5rem;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease;
}

.featured-card:hover {
  transform: translateY(-2px);
}

.featured-card:hover .featured-overlay h2 {
  color: #1cc9a5;
}

.featured-img-wrapper {
  position: relative;
  width: 100%;
  display: block;
  font-size: 0; /* Eliminate small gaps under the img */
}

.featured-img {
  width: 100%;
  height: 500px;
  object-fit: cover;
  display: block;
}

.featured-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 6rem 4rem 3rem;
  background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%);
  color: white;
  text-align: left;
  box-sizing: border-box;
}

.featured-overlay h2 {
  font-family: Times New Roman;
  font-size: 70px;
  font-weight: 500;
  margin-bottom: 0.5rem;
  text-align: left;
  font-style: normal;
  line-height: 70px;
  color: #FFFFFF;
  transition: color 0.25s ease;
}

.featured-date {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 28px;
  text-align: justify;
  font-style: normal;
  }

.featured-overlay p.featured-desc {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: left;
  font-style: normal;
}

/* Grid Cards (2 rows by 3 columns) */
.event-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4.5rem 3.5rem; /* Vertical gap 4.5rem, horizontal gap 3.5rem */
}

.event-card {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: transform 0.25s ease;
}

.event-card:hover {
  transform: translateY(-4px);
}

.event-card:hover .event-details h3 {
  color: #1cc9a5;
}

.event-img {
  width: 100%;
  overflow: hidden;
  border-radius: 4px;
}

.event-img img {
  width: 100%;
  height: 220px;
  object-fit: cover;
}

.event-details {
  margin-top: 1.5rem;
  text-align: left;
}

.event-details h3 {
  font-family: Times New Roman;
  text-align: left;
  font-weight: 500;
  font-size: 24px;
  color: #111111;
  line-height: 28px;
  margin-bottom: 0.6rem;
  transition: color 0.25s ease;
}

.event-date {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #111111;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: justify;
  font-style: normal;
}

.event-desc {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #111111;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  font-style: normal;
}

/* Responsive Layout */
@media (max-width: 1024px) {
  .event-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 3.5rem 2.5rem;
  }
}

@media (max-width: 768px) {
  .events-header {
    padding-top: 80px;
  }
  .header-banner-decor {
    height: 80px;
  }
  .header-content h1 {
    font-size: 2.2rem;
  }
  .event-grid {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
  .featured-overlay {
    padding: 3rem 2rem 2rem;
  }
  .featured-overlay h2 {
    font-size: 2rem;
  }
  .featured-img {
    height: 350px;
  }
}
</style>
